import {
  TripFolderPdfFormInput,
  TripFolderPdfInput,
  TripFolderPdfSectionsEnum
} from '../../../lib/types/models/trip-folder/trip-folder'

export function mapTripFolderPDFFormInputToInput(
  tripFolder: TripFolderPdfFormInput
): TripFolderPdfInput {
  const { printDate, cases, tickets, listOfPax, documentIds } = tripFolder

  const sections: TripFolderPdfSectionsEnum[] = [
    ...(cases ? [TripFolderPdfSectionsEnum.CASES] : []),
    ...(tickets ? [TripFolderPdfSectionsEnum.TICKETS] : []),
    ...(listOfPax?.reservations ? [TripFolderPdfSectionsEnum.RESERVATIONS] : []),
    ...(listOfPax?.centers ? [TripFolderPdfSectionsEnum.CENTERS] : [])
  ]

  return { printDate, sections, documentIds }
}
